import {Component, inject, OnInit, ViewChild, ViewContainerRef} from "@angular/core";
import {AlertService} from "./services/alert.service";
import {NavigationCancel, NavigationEnd, Router} from "@angular/router";
import {UserService} from "./services/user.service";
import {first} from "rxjs";
import {ModalService} from "./shared/data-access/modal.service";
import {Title} from "@angular/platform-browser";
import {environment} from "../environments/environment";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  private titleService = inject(Title);
  @ViewChild("alertContainer", {read: ViewContainerRef, static: true})
  alertContainer: any;
  showSelectedWorkplace: boolean = false;

  constructor(
    private notificationService: AlertService,
    private router: Router,
    protected userService: UserService,
    protected modalService: ModalService
  ) {
  }

  ngOnInit(): void {
    this.titleService.setTitle(environment.appTitle);
    //set the Container where Alert should be displayed and forward info to Service
    this.notificationService.setRootViewContainerRef(this.alertContainer);

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const routesToShowSelectedWorkplace = ["kd", "er", "report"];
        // console.log(event.urlAfterRedirects.split("/"));
        this.showSelectedWorkplace = routesToShowSelectedWorkplace.includes(
          event.urlAfterRedirects.split("/")[1]
        );
      } else if (event instanceof NavigationCancel) {
        // console.log("Sie sind nicht berechtigt, diesen Bereich einzusehen");
      }
    });

    /* this.userService.user$.pipe(first()).subscribe((user) => {
      if (!user && this.router.url !== "/login") {
        this.userService.logout();
      }
    }); */
  }
}
